import getContentfulClient from '../utils/contentfulClient';

let blogPosts = [];

class BlogPost {
  static getImageUrl(field) {
    return field && field.fields && field.fields.file && field.fields.file.url
      ? {
        url: field.fields.file.url,
        type: field.fields.file.details.contentType,
        width: field.fields.file.details.image.width,
        height: field.fields.file.details.image.height,
      }
      : null;
  }

  constructor(entry) {
    this.entry = entry;
    this.id = entry.sys.id;
    this.title = entry.fields.title;
    this.body = entry.fields.body;
    this.extract = entry.fields.extract;
    this.featuredImg = BlogPost.getImageUrl(entry.fields.featuredImg);
    this.listImg = BlogPost.getImageUrl(entry.fields.listImg);
    this.isFeatured = entry.fields.featured;

    if (entry.fields.featuredImgs != null) {
      this.featuredImgs = entry.fields.featuredImgs.map(featuredImg =>
        BlogPost.getImageUrl(featuredImg),
      );
      this.featuredImgs = this.featuredImgs.filter(i => i != null);
    } else {
      this.featuredImgs = [];
    }
  }
}

function findBlogPostByTitle(blogPosts, title) {
  const blogPost = blogPosts.find(b => b.title === title);
  const entryRelatedPosts = blogPost.entry.fields.relatedPosts || [];
  blogPost.relatedPosts = entryRelatedPosts
    .slice(0, 3) // max 3 related posts
    .map(entry => new BlogPost(entry));
  return blogPost;
}

export function fetchAll() {
  if (blogPosts && blogPosts.length !== 0) {
    return Promise.resolve(blogPosts);
  }

  return getContentfulClient()
    .getEntries({
      content_type: 'blogPost',
      order: 'fields.ranking',
    })
    .then(resp => {
      blogPosts = resp.items.map(entry => new BlogPost(entry));
      return blogPosts;
    });
}

export function fetchOne(title) {
  if (blogPosts && blogPosts.length !== 0) {
    return Promise.resolve(findBlogPostByTitle(blogPosts, title));
  }

  return getContentfulClient()
    .getEntries({
      content_type: 'blogPost',
      order: 'fields.ranking',
    })
    .then(resp => {
      blogPosts = resp.items.map(entry => new BlogPost(entry));
      return findBlogPostByTitle(blogPosts, title);
    });
}



// WEBPACK FOOTER //
// ./src/stores/BlogPostStore.js